import axios from 'axios'
import {Int} from "@/api/type";
import Cookies from "js-cookie";

const REAL_URL = 'https://api.taipec.gugame.net/index.php?/'

let token = Cookies.get('TOKEN') || ''
let id = Cookies.get('ID') || ''
let auth = Cookies.get('AUTH') || 0

function setData(TOKEN: string = '', AUTH: string = '', ID: string = '') {
    Cookies.set('TOKEN', TOKEN)
    Cookies.set('AUTH', AUTH)
    Cookies.set('ID', ID)
    token = TOKEN
    auth = AUTH
    id = ID
}

export const resetData = () => {
    setData();
}
export const initAccountData = (ID: string, AUTH: number, TOKEN: string) => {
    setData(TOKEN, String(AUTH), ID)
};

export const getToken = () => token
export const getAuth = () => auth
export const getId = () => id

export const isLogin = () => getToken() !== ''

interface RestApiData {
    RES: number
}

interface RestApiResult {
    data: RestApiData
}

const checkApiResult = (result: any) => {
    console.log('api checkApiResult', result);
    let {data} = result
    if (typeof data === 'string') {
        // FIXME: 後端資料有問題, 先用假資料長畫面
        try {
            data = JSON.parse(data)
        } catch (e) {
            data = {
                "RES": 1,
                "OID": 2,
                "ORDER": [
                    {"PID": "56TF70B20", "PN": "豐葵香瓜子(焦糖) TF - Sunflower Seeds Caramel", "AMOUNT": 9},
                    {"PID": "14TS11B24", "PN": "荔枝椰果汁 TS - Lychee With Coconut Jelly Drink", "AMOUNT": 3}
                ]
            }
        }
    }
    if (data.RES === 1) {
        console.log('Access pass:', data);
        return data
    } else {
        console.log('Access denied');
        throw new Error('Access denied')
    }
}

function simplifyRequest<T, U>(resource: string = "", method: string = "POST") {
    return function (params: T) {
        const paramWithToken = {...params, TOKEN: token}
        let url = REAL_URL + resource
        console.log(url);

        switch (method) {
            case "POST":
            default:
                return axios.post<U>(url, paramWithToken)
                    .then(checkApiResult)
                    .catch((reason: string) => {
                        console.log('network problem:', reason);
                        throw new Error(reason)
                    });
        }
    };
}

interface ReqCheckToken {
    ID: string
    // TOKEN: string
}

interface ResCheckToken {
    RES: Int
}

interface ReqAccountLogin {
    ID: string
    PWD?: string
}

interface ResAccountLogin {
    RES: Int
    // TOKEN?: string
    AUTH: Int
}

interface ReqAccountRegister {
    // TOKEN: string
    ID: string
    PWD: string
    NAME: string
}

interface OnlyRes {
    RES: Int
}

interface ResAccountList {
    RES: Int
    LIST: {
        EID: Int
        NAME: string
        MAIL: string
        AUTH: Int
    }[]
}

interface ReqAccountPwdEdit {
    // TOKEN: string
    EID: Int
    PWD: string
}

interface ReqAccountAuthEdit {
    // TOKEN?: string
    EID: Int
    AUTH: Int
}

interface ResUserList {
    RES: Int
    LIST: {
        UID: Int
        NAME: string
        VIP_LEVEL: Int
        MEMO: string
        OWNER: {
            EID: number
            NAME: string
        }[]
    }[]
}

interface ReqUserAuthorize {
    // TOKEN: string
    UID: Int
    VIP: Int
}

interface ReqUserEdit {
    // TOKEN: string
    UID: Int
    EID: Int
    MEMO: string
}

// 20210417 add
interface ReqAccountDel {
    AID: Int
}

interface ReqAccountEditName {
    EID: Int
    NAME: string
}

interface ReqAccountEditEmail {
    EID: Int
    EMAIL: string
}

interface ReqUserDel {
    UID: Int
}

interface ReqOrderList {
    SDATE: Int,
    DDATE: Int
}

interface ReqOrderDel {
    OID: Int
}

interface ReqAnnouncementDel {
    AID: Int
}

interface ReqAnnouncementOrder {
    AID: Int
    ORDER: Int
}

interface ReqUserRSPEdit {
    UID: Int
    LIST: {
        EID: Int,
        ACT: Int,
    }[]
}


export const accountLogin = simplifyRequest<ReqAccountLogin, ResAccountLogin>("Account/Login");
export const checkToken = simplifyRequest<ReqCheckToken, ResCheckToken>("Account/Login");
export const accountRegister = simplifyRequest<ReqAccountRegister, OnlyRes>("Account/Register");
export const accountList = simplifyRequest<void, ResAccountList>("Account/List");
export const accountPasswordEdit = simplifyRequest<ReqAccountPwdEdit, OnlyRes>("Account/PwdEdit");
export const accountAuthEdit = simplifyRequest<ReqAccountAuthEdit, OnlyRes>("Account/AuthEdit");
export const accountDel = simplifyRequest<ReqAccountDel, OnlyRes>("Account/Del");
export const accountEditName = simplifyRequest<ReqAccountEditName, OnlyRes>("Account/NameEdit");
// export const accountEditMail = simplifyRequest<ReqAccountEditEmail, OnlyRes>("Account/AuthEdit");
export const userList = simplifyRequest<void, ResUserList>("User/List");
export const userAuthorize = simplifyRequest<ReqUserAuthorize, OnlyRes>("User/Authorize");
export const userEdit = simplifyRequest<ReqUserEdit, OnlyRes>("User/Edit");
export const userDel = simplifyRequest<ReqUserDel, OnlyRes>("User/Del");
export const userRspEdit = simplifyRequest<ReqUserRSPEdit, OnlyRes>("User/RSPEdit")
export const orderList = simplifyRequest<ReqOrderList,
    {
        RES: Int
        LIST: {
            OID: Int
            NAME: string
            DATE: string
            MEMO: string
            AMOUNT: Int
        }[]
    }>("Order/List")
export const orderDel = simplifyRequest<{ OID: Int }, OnlyRes>('Order/Del')

interface ReqOrderDetail {
    OID: Int
}

export const orderDetail = simplifyRequest<ReqOrderDetail, {
    RES: Int
    OID: Int
    ORDER: {
        PID: string
        PN: Int
        AMOUNT: Int
    }[]
}>("Order/Detail")
export const orderMemo = simplifyRequest<{
    OID: Int
    MEMO: string
}, OnlyRes>("Order/Memo")
export const storeList = simplifyRequest<{ PAGE: number, AMOUNT: number }, {
    RES: Int
    VER: Int
    AMOUNT: Int
    DATE: string
    LIST: {
        PID: string
        PIC: string
        CATEGORY: string
        SUBTYPE: string
        PNAME: string
        VIP1: number
        VIP2: number
        TAG: string
        DESC: string
    }[]
}>("Store/List")
export const announceList = simplifyRequest<void, {
    RES: Int
    LIST: {
        AID: Int
        CODE: string
        PIC: string
        LINK: string
        SDATE: string
        EDATE: string
    }[]
}>("Announcement/List")
export const announceEdit = simplifyRequest<{
    TOKEN?: string
    AID: Int
    CODE: string
    LINK: string
    SDATE: string
    EDATE: string
},
    {
        RES: Int
        AID?: Int
    }>("Announcement/Edit")

export const announceOrder = simplifyRequest<{ AID: Int, Order: Int }, OnlyRes>('Announcement/Order')

export const announceDel = simplifyRequest<{ AID: Int }, OnlyRes>('Announcement/Del')

